import type { AsrModelRow, AsrProviderOptionMapping } from '../api/types';

type TProviderOptionAvailability = {
  available: boolean;
  detail?: string;
};

export const getProviderOptionAvailability = (
  option: string,
  model: AsrModelRow | undefined,
  mapping: AsrProviderOptionMapping | undefined,
): TProviderOptionAvailability => {
  if (!model) {
    return { available: false, detail: 'Select a model first' };
  }
  if (!mapping) {
    return { available: false, detail: 'No provider mapping is declared' };
  }
  if (mapping.status === 'controlled' || mapping.status === 'unavailable') {
    return { available: false, detail: mapping.detail };
  }
  if (model.supported_options !== null && !model.supported_options.includes(option)) {
    return { available: false, detail: 'The selected model does not support this parameter' };
  }
  return { available: true };
};
